import { inject, Pipe, PipeTransform } from '@angular/core';
import { ItemForDisplay, ItemPriceLevels, PriceLevelTypes } from '../../models';
import { AppStateService } from '../../services';

@Pipe({
  name: 'itemPrice',
  standalone: true,
  pure: true,
})
export class ItemPricePipe implements PipeTransform {
  appStateService = inject(AppStateService);

  /** 
   * @param priceLevel the price level to display
  * If a price level is supplied it will show that price otherwise
  * it will default to the price level set in the backend.
  * If the items HidePrice is set to true it returns null.
  */
  transform(item: ItemForDisplay, priceLevel?: PriceLevelTypes): number | null {
    return getItemPrice(item, this.appStateService.getUserPriceLevel(), priceLevel);
  }
}

export function getItemPrice(item: ItemForDisplay, userPriceLevel: PriceLevelTypes, priceLevel?: PriceLevelTypes): number | null {
  if (item.HidePrice) {
    return null;
  }

  if (priceLevel) {
    return item[getItemPriceProperty(priceLevel)];
  }

  return item[getItemPriceProperty(userPriceLevel)];
}

export function getItemPriceProperty(priceLevel: PriceLevelTypes): keyof ItemPriceLevels {
  switch (priceLevel) {
    case 'Our Price': return 'OurPrice';
    case 'Price A': return 'PriceA';
    case 'Price B': return 'PriceB';
    case 'Price C': return 'PriceC';
    case 'Retail Price': return 'RetailPrice';
    case 'Minimum Price': return 'MinPrice';
    case 'ActiveePrice': throw new Error('cannot use ActiveePrice for price level');
    default: return 'OurPrice';
  }
}
